import {
  Box,
  Checkbox,
  FormControlLabel as MuiFormControlLabel,
  styled,
  Typography,
} from '@mui/material';

export const FixedWidthColumn = styled(Box)(
  ({ theme }) => `
  width: 400px;
  background:${theme.palette.primary.lightest};
  border-right: 1px solid ${theme.palette.brand.disable};
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-right: 20px;
  
  & form {
    & .MuiFormHelperText-root {
      margin-left: 0;
    }
  }
`,
);

export const Header = styled(Box)(
  ({ theme }) => `
    border-bottom: 1px solid ${theme.palette.brand.charcoal};
    height: 50px;
    display: flex;
    justify-content: flex-start;
    align-items: center;`,
);

export const HeaderText = styled(Typography)`
  font-size: 16px;
  font-weight: 400;
`;

export const ButtonWrapper = styled(Box)`
  padding-bottom: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  padding-right: 20px;
`;

export const FormControlLabel = styled(MuiFormControlLabel)`
  align-items: flex-start;
`;

export const FormCheckbox = styled(Checkbox)`
  padding-top: 5px;
`;
